// extracted by mini-css-extract-plugin
module.exports = {"button":"Navbar_button__bjt6k"};